import { createSelector } from "reselect";

import { isReturn } from "@app/helpers/search";
import { getDisplayPrice } from "@app/helpers/udm/get-display-price";

import { getDisplayedPriceConfig } from "../get-displayed-price-config";
import { getSearch, getTrips } from "../state-accessors";

export const getTripsMaxMinPrice = createSelector(
  [getTrips, getSearch, getDisplayedPriceConfig],
  (trips, search, displayed_price_config) => {
    const direction = isReturn(search) ? "return" : "outbound";

    const result = Object.values(trips).map(trip =>
      getDisplayPrice(trip, direction, displayed_price_config)
    );

    return { max: Math.max(...result), min: Math.min(...result) };
  }
);
